<mat-radio-group aria-label="Select an option">
  @for (item of options; track item) {
    <mat-radio-button value="{{item}}">{{item}}</mat-radio-button>
  }
</mat-radio-group>
